export default function numberWithSpaces(x) {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : x;
};



// WEBPACK FOOTER //
// ./src/scripts/NumberWithSpaces.js